import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "TheHeaderNavItem nav-item" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["href", "aria-label"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "dropdown-menu"
}
const _hoisted_6 = {
  key: 0,
  class: "dropdown-menu__item"
}
const _hoisted_7 = {
  key: 1,
  class: "dropdown-menu__item"
}
const _hoisted_8 = ["href", "aria-label"]
const _hoisted_9 = {
  key: 2,
  class: "dropdown-menu__item"
}
const _hoisted_10 = ["href", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (_ctx.currentApp)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: _ctx.path,
          class: _normalizeClass(["nav-item__link", { 'is--not-clickable': !_ctx.clickable }]),
          "aria-label": `Click on ${_ctx.name} link`
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.name), 1),
            (_ctx.hasChildren)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "svg-icon nav-item__link-icon",
                  alt: "Carrot",
                  innerHTML: require(`!!raw-loader!images/icons/new-chevron-down.svg`).default
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to", "class", "aria-label"]))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.path,
          class: _normalizeClass(["nav-item__link", { 'is--not-clickable': !_ctx.clickable }]),
          "aria-label": `Click on ${_ctx.name} link`
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.name), 1),
          (_ctx.hasChildren)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "svg-icon nav-item__link-icon",
                alt: "Carrot",
                innerHTML: require(`!!raw-loader!images/icons/new-chevron-down.svg`).default
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ], 10, _hoisted_3)),
    (_ctx.hasChildren)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (subMenuItem, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (subMenuItem.currentApp)
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      to: subMenuItem.path,
                      class: "dropdown-menu__item-link",
                      "aria-label": `Click on ${subMenuItem.name} link`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(subMenuItem.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "aria-label"])
                  ]))
                : (subMenuItem.path.startsWith('/'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                      _createElementVNode("a", {
                        href: subMenuItem.path,
                        class: "dropdown-menu__item-link",
                        "aria-label": `Click on ${subMenuItem.name} link`
                      }, [
                        _createElementVNode("span", null, _toDisplayString(subMenuItem.name), 1)
                      ], 8, _hoisted_8)
                    ]))
                  : (_openBlock(), _createElementBlock("li", _hoisted_9, [
                      _createElementVNode("a", {
                        href: subMenuItem.path,
                        target: "_blank",
                        class: "dropdown-menu__item-link",
                        "aria-label": `Click on ${subMenuItem.name} link`
                      }, _toDisplayString(subMenuItem.name), 9, _hoisted_10)
                    ]))
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}